
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M.582.583h5.5v5.5h-5.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M.582 7.917h5.5v5.5h-5.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M7.918.583h5.5v5.5h-5.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M7.918 7.917h5.5v5.5h-5.5z"}})])
          )
        }
      }
    